export enum IndexType {
  SIM = "SIM",
  SIPI = "SIPI",
  SEPI = "SEPI",
  SIPN = "SIPN",
  //VALUATION_AIPI = "VALUATION_AIPI",
  CRR3 = "CRR3",
}
